<template>
  <span v-if="isVisible" class="import-test-ctn">
    <ba-button class="danger" :disabled="loading" @click.native="pickFile">
      {{ loading ? 'Import en cours...' : 'Importer CSV clients (test slmnt)' }}
    </ba-button>

    <input
      ref="fileInput"
      type="file"
      accept=".csv,text/csv"
      class="import-test-input"
      @change="handleFile"
    >

    <modal class="modal" name="importClientTest" width="640px" height="auto" :scrollable="true">
      <ba-card>
        <template slot="header">
          <span>Rapport d'import client</span>
        </template>
        <template>
          <p v-if="errorText" class="import-test-error">{{ errorText }}</p>
          <div v-else>
            <p>
              <strong>{{ report.clientInsert }}</strong> client(s) inséré(s),
              <strong>{{ report.clientUpdate }}</strong> mis à jour.
            </p>
            <p v-if="!reportErrors.length">Aucune erreur signalée.</p>
            <div v-else>
              <p>{{ reportErrors.length }} ligne(s) rejetée(s) :</p>
              <ul class="import-test-errors">
                <li v-for="(err, index) in reportErrors" :key="index">
                  ligne {{ err.row }} — {{ err.field }} — {{ err.error }}
                </li>
              </ul>
            </div>
          </div>
        </template>
        <template slot="footer">
          <div class="buttons-container flex flex-center">
            <ba-button class="primary" @click.native="$modal.hide('importClientTest')">
              Fermer
            </ba-button>
          </div>
        </template>
      </ba-card>
    </modal>
  </span>
</template>

<script>
import { BaButton, BaCard } from '@ab/basic-components';
import { createRequest, handleError } from '@/api/api.js';

const request = createRequest();

const ALLOWED_ENVS = [ 'development', 'staging', 'qa' ];
const TEST_USER_ID = 1;
const TEST_USER_EMAIL = 'user@abtech.co';

export default {
  name: 'MoImportClientTest',
  components: {
    BaButton,
    BaCard
  },
  data() {
    return {
      loading: false,
      errorText: '',
      report: { clientInsert: 0, clientUpdate: 0, errors: [] }
    };
  },
  computed: {
    isVisible() {
      const env = String(process.env.VUE_APP_ENV || process.env.NODE_ENV || '').toLowerCase();
      if (ALLOWED_ENVS.indexOf(env) === -1) return false;

      const user = this.$store.getters.getUser;
      if (!user) return false;
      return Number(user.id) === TEST_USER_ID
        && String(user.email).toLowerCase() === TEST_USER_EMAIL;
    },
    reportErrors() {
      return (this.report && this.report.errors) || [];
    }
  },
  methods: {
    pickFile() {
      if (this.loading) return;
      const confirmed = window.confirm(
        'Cet import MAJ les tables Client, Address et Client_Address '
        + '\n\nA lancer que sur une base de test.'
      );
      if (confirmed) this.$refs.fileInput.click();
    },
    async handleFile(event) {
      const file = event.target.files && event.target.files[0];
      this.$refs.fileInput.value = '';
      if (!file) return;

      this.loading = true;
      this.errorText = '';
      this.$store.commit('setSpinner', true);
      try {
        const formData = new FormData();
        formData.append('fileUpload', file, file.name);

        const data = await request.post('/import/client-manual', formData, {
          headers: {
            'Authorization': this.$store.getters.getToken,
            'Content-Type': 'multipart/form-data'
          }
        }).then(res => res.data).catch(handleError);

        if (data === false || data === undefined) {
          this.errorText = "L'import a échoué. Détail dans motrium-api/logs/error.log.";
        } else if (data && typeof data === 'object') {
          this.report = {
            clientInsert: data.clientInsert || 0,
            clientUpdate: data.clientUpdate || 0,
            errors: data.errors || []
          };
        } else {
          this.report = { clientInsert: 0, clientUpdate: 0, errors: [] };
        }
        this.$modal.show('importClientTest', {});
      } finally {
        this.loading = false;
        this.$store.commit('setSpinner', false);
      }
    }
  }
};
</script>

<style scoped>
.import-test-ctn {
  margin-left: 1rem;
}
.import-test-input {
  display: none;
}
.import-test-errors {
  max-height: 280px;
  overflow-y: auto;
  margin-top: 0.5rem;
  padding-left: 1.2rem;
}
.import-test-errors li {
  font-size: 0.85rem;
}
.import-test-error {
  color: var(--ba-button-bg-danger, #d9534f);
}
</style>
